export default "__VITE_ASSET__ByenKboZ__"